import { RunMode } from '../../constants/Configuration';

export const getRunMode = (configuration, batchStore) => {
  const data = batchStore.running.length ? batchStore.running[0] : null;
  return data?.runMode || configuration?.runMode;
};

export const isRunModeNewYork = (runMode = '') => {
  //TODO: this replace is needed because API might return both version with/without space
  runMode = (runMode ?? '').replace(' ', '');
  return runMode === RunMode.NewYork;
};
